"use client";

import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import BenefitCard from "./BenefitCard";
import { SectionContainer, TwoColumnLayout } from "./layouts";

interface DiagramIcon {
  icon: React.ReactNode;
  label: string;
  labelLines?: string[];
}

interface BenefitCardData {
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
}

interface DiagramBenefitsSectionProps {
  centerIcon: DiagramIcon;
  leftIcon: DiagramIcon;
  rightIcon: DiagramIcon;
  benefitCards: BenefitCardData[];
  className?: string;
}

const DiagramBenefitsSection: React.FC<DiagramBenefitsSectionProps> = ({
  benefitCards,
  className,
}) => {
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    import("@/public/animations/Gondola_EarnChart_Lottie.json").then((mod) =>
      setAnimationData(mod.default)
    );
  }, []);

  return (
    <SectionContainer background="transparent" className={className}>
      <TwoColumnLayout
        className="lg:items-center"
        leftContent={
          <div className="relative flex w-full items-center justify-center">
            {animationData ? (
              <Lottie
                animationData={animationData}
                loop={true}
                autoplay={true}
                className="h-auto w-full max-w-[627px]"
              />
            ) : (
              <div className="h-[400px] w-full max-w-[627px]" />
            )}
          </div>
        }
        rightContent={
          <div className="flex w-full items-center justify-center">
            <div className="inline-flex w-full max-w-[456px] flex-col items-center justify-center gap-4">
              {benefitCards.map((benefit, index) => (
                <BenefitCard
                  key={index}
                  icon={benefit.icon}
                  title={benefit.title}
                  description={benefit.description}
                />
              ))}
            </div>
          </div>
        }
        gap="xl"
      />
    </SectionContainer>
  );
};

export default DiagramBenefitsSection;
